import { FC } from 'react';

type Props = {
	className?: string;
};

const ArrowRight_01_SharpIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M9 14L12.2929 10.7071C12.6262 10.3738 12.7929 10.2071 12.7929 10C12.7929 9.79289 12.6262 9.62623 12.2929 9.29289L9 6'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ArrowRight_01_SharpIcon;
